import {Injectable, PLATFORM_ID, inject} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

const TOKEN_KEY = 'jwtToken';

@Injectable({ providedIn: 'root' })
export class JwtService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private token: string | null = null;

  getToken(): string | null {
    if (!this.isBrowser) {
      return null;
    }
    return window.localStorage.getItem(TOKEN_KEY) ?? this.token;
  }

  saveToken(token: string): void {
    if (!this.isBrowser) {
      return;
    }
    this.token = token;
    window.localStorage.setItem(TOKEN_KEY, token);
  }

  destroyToken(): void {
    if (!this.isBrowser) {
      return;
    }
    this.token = null;
    window.localStorage.removeItem(TOKEN_KEY);
  }
}
